import { useTranslation } from "react-i18next";

const RedeemHistory = () => {
  const { t } = useTranslation();
  const historyData = [];
  return (
    <div className="flex-col justify-center font-poppins bg-white w-[95vw] sm:w-[800px] lg:h-[70vh] md:h-[65vh] h-[55vh]  rounded-3xl p-10">
      <h2 className="text-xl text-center text-[#6B6B6B] font-semibold mb-4">{t("redeem.history.redeemhistory")}</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse text-[#474747]">
          <thead>
            <tr>
              <th className="px-4 py-3 font-medium text-center text-[#474747]">{t("redeem.history.No")}</th>
              <th className="px-4 py-3 font-medium text-center text-[#474747] w-32">{t("redeem.history.Date2")}</th>
              <th className="px-4 py-3 font-medium text-center  text-[#474747]">{t("redeem.history.Reward")}</th>
              <th className="px-4 py-3 font-medium text-center  text-[#474747]">{t("page.history.Status")}</th>
            </tr>
          </thead>
          <tbody>
            {historyData.map((item, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="px-4 py-3 border-b border-[#E2E2E2] text-center text-[#474747]">
                  {index}
                </td>
                <td className="px-4 py-3 border-b border-[#E2E2E2] text-center text-[#474747]">
                  {item.date}
                </td>
                <td className="px-4 py-3 border-b border-[#E2E2E2] text-center text-[#474747]">
                  {item.gift}
                </td>
                <td
                  className={`px-4 py-3 border-b border-[#E2E2E2] text-center font-semibold ${
                    item.status === "Successful" ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {item.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    // </div>
  );
};

export default RedeemHistory;
